// extracted by mini-css-extract-plugin
export default {"configuratorModalInner":"configuratorModalInner--Hde_Z","productList":"productList--KF53x","specficationBody":"specficationBody--to7qO"};